import { ENV } from '@app/env';

export let END_POINT: string = ENV.api;

if (document.URL.indexOf('http://localhost:81') === 0) {
  END_POINT = ENV.proxy + '/api/';
} else {
  if (ENV.mode == 'PROD') {
    END_POINT = ENV.api + '/api/';
  } else {
    // Ambiente de homologação é possível alterar em tempo de execução
    const manuallyApiUrl: string = localStorage.getItem('apiUrl');
    if (manuallyApiUrl) {
      END_POINT = manuallyApiUrl + '/api/';
    } else {
      END_POINT = ENV.api + '/api/';
    }
  }
}

// tslint:disable-next-line:typedef
export const APP_CONFIG = {
  // ENV: ENV,
  SERVER_SELECTED: ENV.api,
  API_KEY: 'FASTGETPUBAPI',
  APP_VERSION: '2.43.0',
  SHOW_RELEASE_NOTES: true, // mudar para false quando não tiver novidades para mostrar, como um hotfix
  WEBSITE: {
    SITE: 'https://fastget.com.br',
    PLANS: 'https://fastget.com.br/planos',
    TERMS: 'https://fastget.com.br/termos-parceiro-content.html',
    PRIVACY: 'https://fastget.com.br/privacidade-content.html',
    BLOG: 'https://blog.fastget.com.br/',
    APP_WEB: 'https://app.fastget.com.br/',
  },
  GA_TAG_CONVERSION_VALUE: 'AW-653257022/clOPCLG3qswBEL7Sv7cC',
  WHATSAPP_NUMBER: '5543988361973',
  PAYMENT_API_URL: 'https://faturas.iugu.com/',
  PIX_QRCODE_PAYMENT_API_URL: 'https://qr.iugu.com/public/v1/qr_codes/image/', // + ID
  NORMA_BANCO_CENTRAL_URL:
    'https://www.bcb.gov.br/pre/normativos/busca/downloadNormativo.asp?arquivo=/Lists/Normativos/Attachments/50905/Circ_3978_v1_O.pdf',
  WEBSERVICE: {
    //Public
    GET_ACTIVE_PLANS: END_POINT + 'v1/public/plans/active',
    SAVE_STORE: END_POINT + 'v1/public/storeregister',
    SAVE_PRE_STORE: END_POINT + 'v1/public/storeregister/pre',
    SEND_EMAIL_CODE: END_POINT + 'v1/public/storeregister/sendEmailValidation',
    VERIFY_UPDATE_PASSWORD_LINK:
      END_POINT + 'v1/public/users/verifyUpdatePasswordLink?emailToken={token}',
    ACTIVE_ACCOUNT: END_POINT + 'v1/public/users/activeAccount',
    FORGOT_PASSWORD: END_POINT + 'v1/public/users/forgotPassword',
    CREATE_PASSWORD: END_POINT + 'v1/public/users/createPassword',
    UPDATE_PASSWORD: END_POINT + 'v1/public/users/updatePassword',
    VALIDATE_EMAIL: END_POINT + 'v1/public/users/validate?email=',
    VALIDATE_CNPJ: END_POINT + 'v1/public/stores/validate?cnpj=',
    CREATE_PASSWORD_NEW_USER: END_POINT + 'v1/public/users/createPasswordNewUser',
    AUTH_TOKEN: END_POINT + 'v1/oauth/token',
    SEND_GENERIC_EMAIL: END_POINT + 'v1/public/comunicatons',

    // Protected
    // ------------------------

    //SYSTEM
    API_VERSION_SYSTEM: END_POINT + 'v1/public/apiversion',
    APP_VERSION: END_POINT + 'v1/public/version/front',

    //TRANSLATIONS
    TRANSLATION: END_POINT + 'v1/protected/translation',
    AUTO_TRANSLATION: END_POINT + 'v1/protected/translation/automatic-translation',

    //STORE
    UPDATE_ESTAB: END_POINT + 'v1/protected/stores',
    UPDATE_STORE_IDENTITY: END_POINT + 'v1/protected/stores/saveEstablishmentIdentity',
    UPDATE_STORE_DATA: END_POINT + 'v1/protected/stores/companyData',
    UPDATE_STORE_ADDRESS: END_POINT + 'v1/protected/stores/{storeId}/address',
    UPDATE_BUSINESS_MODEL: END_POINT + 'v1/protected/stores/businessModel',
    UPDATE_BUSINESS_PAYMENTS: END_POINT + 'v1/protected/stores/businessModelPayment',
    GET_ESTABLISHMENT_DATA: END_POINT + 'v1/protected/stores/{estabId}',
    CHANGE_ESTAB_STATUS: END_POINT + 'v1/protected/stores/changestatus',
    OPEN: END_POINT + 'v1/protected/stores/open/',
    CLOSE: END_POINT + 'v1/protected/stores/close/',
    CHECK_PENDENCIES:
      END_POINT + 'v1/protected/establishmentPendings?establishmentId={estabId}&status=PENDING',
    PENDENCIES: END_POINT + 'v1/protected/storePendings',
    SAVE_BRANCH: END_POINT + 'v1/protected/stores/branchs',
    //CHECK_REMAINING_DAYS_TRIAL: END_POINT + "v1/protected/store-info/remainingDaysTrial?storeId={storeId}",
    VALIDATE_COUPON: END_POINT + 'v1/public/coupons/storeSubscription?coupon=',
    CREATE_STORE_PAYMENT_ID: END_POINT + 'v1/protected/stores/{storeId}/createPaymentId',
    COPY_MENU_TO_STORE: END_POINT + 'v1/protected/copy-menu',

    PAYMENT_METHODS: END_POINT + 'v1/protected/stores/{storeId}/paymentMethod',

    //RESERVATION
    GET_RESERVATION_CONFIG:
      END_POINT + 'v2/public/tablereservationconfig?storeId={storeId}&configType={configType}',
    REMOVE_RESERVATION_CONFIG: END_POINT + 'v1/protected/tablereservationconfig/{configId}',
    RESERVATION_CONFIG_V2: END_POINT + 'v2/protected/tablereservationconfig',
    RESERVATION_CONFIG_STATUS: END_POINT + 'v1/protected/tablereservationconfig/updatestatus',
    GET_RESERVATION_TABLES: END_POINT + 'v1/protected/tablereservationhours?storeId={storeId}',
    RESERVATION_TABLES: END_POINT + 'v1/protected/tablereservationhours',
    GET_RESERVATION_AVAILABILITY:
      END_POINT +
      'v1/public/tablereservation/availability?storeId={storeId}&startDate={startDate}&endDate={endDate}',
    RESERVATION_AVAILABILITY: END_POINT + 'v1/protected/tablereservation/availability',
    GET_RESERVATION_HOURS_AVAILABILITY:
      END_POINT + 'v1/public/tablereservation/hoursavailability?date={date}&storeId={storeId}',
    GET_APPROVED_RESERVATION_LIST:
      END_POINT +
      'v1/protected/tablereservation?storeId={storeId}&status=APPROVED&reservationDate={reservationDate}&typeOfQuery={typeOfQuery}&orderByReservationDate=asc',
    GET_WAITING_RESERVATION_LIST:
      END_POINT +
      'v1/protected/tablereservation?storeId={storeId}&status={status}&orderByReservationDate=asc',
    GET_CANCELED_RESERVATION_LIST:
      END_POINT +
      'v1/protected/tablereservation?storeId={storeId}&status={status}&size={size}&page={page}&orderByReservationDate=desc',
    CANCEL_RESERVATION: END_POINT + 'v1/protected/tablereservation/cancel',
    RESERVATION: END_POINT + 'v1/protected/tablereservation',
    APPROVE_RESERVATION: END_POINT + 'v1/protected/tablereservation/approve',
    RESERVATION_CHECKIN: END_POINT + 'v1/protected/tablereservation/present',
    RESERVATION_SUMMARY:
      END_POINT + 'v1/protected/tablereservation/summary?date={date}&storeId={storeId}',
    RESERVATION_SECTORS: END_POINT + 'v1/protected/stores/{storeId}/sectors',
    TABLES_CONF: END_POINT + 'v1/protected/stores/{storeId}/tableseatconf',
    RESERVATION_SECTORS_HOURS:
      END_POINT + 'v1/protected/tablereservationhours/sectors/stores/{storeId}',
    RESERVATION_REPORT:
      END_POINT +
      'v1/protected/report/stores/{storeId}/table-reservation?startDate={startDate}&endDate={endDate}&orderType={orderType}&page={page}&size={size}',
    EXPORT_RESERVATION_REPORT:
      END_POINT +
      'v1/protected/report/export/stores/{storeId}/table-reservation?startDate={startDate}&endDate={endDate}&orderType={orderType}',

    // SPECIAL DATES
    GET_SPECIAL_DATES:
      END_POINT + 'v1/protected/tablereservationconfig/special-dates?storeId={storeId}',
    SPECIAL_DATE_SEATS_CONFIG:
      END_POINT + 'v1/protected/tablereservationconfig/{configId}/seat-config',
    SPECIAL_DATE_HOURS_AVAILABILITY:
      END_POINT + 'v1/protected/tablereservationconfig/{configId}/hours-availability',

    // SHORT LINK
    SAVE_SHORT_LINK: END_POINT + 'v1/protected/shortLink',

    //DELIVERY
    GET_DELIVERY_FEE: END_POINT + 'v1/public/deliveryFees',
    DELIVERY_FEE: END_POINT + 'v1/protected/deliveryFees',

    // PARAMS
    SAVE_PARAMS: END_POINT + 'v1/protected/params',
    GET_PARAMS: END_POINT + 'v1/protected/params?type={type}&referenceId={referenceId}&keys={keys}',

    //RESTAURANT USER INFO
    USER_INFO: END_POINT + 'v1/protected/stores/users/info',

    //BUSINESS HOURS
    GET_BUSINESS_HOURS: END_POINT + 'v1/public/businesshours?establishmentId={estabId}',
    SAVE_BUSINESS_HOURS: END_POINT + 'v1/protected/businesshours',

    //TABLES
    TABLES: END_POINT + 'v1/protected/tables',

    // TABLES PAYMENTS
    GET_TABLES_PAYMENTS:
      END_POINT + 'v1/protected/tablesPayments?establishmentId={establishmentId}',
    GET_CUSTOMER_ORDERS_PENDING_PAYMENT:
      END_POINT +
      'v2/protected/orders?establishmentId={establishmentId}&userId={userId}&tableId={tableId}&paymentStatus=PENDING&status=IN_QUEUE,IN_PRODUCTION,PARTIAL_DELIVERED,FINISHED,DELIVERED,RATED&orderByDtDesc=true',
    CONFIRM_MANUAL_PAYMENT: END_POINT + 'v1/protected/payment/manual',
    GET_ORDERS_PENDING:
      END_POINT +
      'v2/protected/orders?establishmentId={establishmentId}&paymentStatus={paymentStatus}', //&pickupOptions=TO_GO, FOR_HERE"

    //CATEGORIES
    GET_CATEGORIES: END_POINT + 'v1/public/categories/uuid?storeUuid={storeUuid}',
    GET_ALL_MENU:
      END_POINT + 'v1/public/categories/uuid?storeUuid={storeUuid}&withProducts=true&customer=true',
    CATEGOY: END_POINT + 'v1/protected/categories',
    PUT_CATEGORY_REORDER: END_POINT + 'v1/protected/categories/reorder',
    CHANGE_ALL_PRODUCTS_MENU_AVAILABILITY: END_POINT + 'v1/protected/categories/menuAvailability',

    //PRODUCT
    GET_PRODUCTS: END_POINT + 'v1/public/products',
    PRODUCTS: END_POINT + 'v1/protected/products',
    PRODUCTS_DUPLICATE: END_POINT + 'v1/protected/products/duplicate',
    PRODUCTS_REORDER: END_POINT + 'v1/protected/products/reorder',
    CHANGE_MENU_AVAILABILITY: END_POINT + 'v1/protected/products/menuAvailability',

    //COMPLEMENTS
    GET_COMPLEMENTS: END_POINT + 'v1/public/complements',
    COMPLEMENTS: END_POINT + 'v1/protected/complements',
    COMPLEMENTS_DUPLICATE: END_POINT + 'v1/protected/complements/duplicate',
    COMPLEMENTS_REORDER: END_POINT + 'v1/protected/complements/reorder',
    COMPLEMENT_OPTIONS: END_POINT + 'v1/protected/complementOptions',

    GET_PRODUCT_AVAILIBILITY: END_POINT + 'v1/public/producthours?productId={productId}',
    SAVE_PRODUCT_AVAILIBILITY: END_POINT + 'v1/protected/producthours',

    //PHOTOS
    GET_PHOTOS: END_POINT + 'v1/protected/photos/',
    PHOTOS: END_POINT + 'v1/protected/photos/',

    //USERS
    STORE_USERS: END_POINT + 'v2/protected/stores/{storeId}/users',
    UPDATE_PASSWORD_FROM_VIEW: END_POINT + 'v1/protected/users/updatePassword',
    // USERS PLACE
    PLACE_USERS: END_POINT + 'v1/protected/places/{placeId}/users',

    //BANK_ACCOUNT
    BANK_ACCOUNT: END_POINT + 'v1/protected/bankAccount',
    // FECHAMENTO
    GET_STATEMENTS:
      END_POINT +
      'v1/protected/payment/statements?establishmentId={establishmentId}&size={size}&page={page}&count={count}',
    GET_STATEMENT: END_POINT + 'v1/protected/payment/statements/',

    // RECEIVABLES
    GET_RECEIVABLES:
      END_POINT +
      'v1/protected/transactions?startDate={startDate}&endDate={endDate}&size={size}&page={page}',
    GET_FORECAST: END_POINT + 'v1/protected/transactions/forecast?',
    GET_PLACE_FORECAST_DETAILS:
      END_POINT + 'v1/protected/transactions/forecast/details?placeId={placeId}&endDate={date}',

    //ORDERS
    GET_PENDING_ORDERS:
      END_POINT +
      'v2/protected/orders?status=RESERVED,IN_QUEUE,IN_PRODUCTION,PARTIAL_DELIVERED,FINISHED&orderByDtDesc=false',
    GET_FINISHED_ORDERS:
      END_POINT +
      'v2/protected/orders?status=DELIVERED,RATED,CANCELED_BY_ESTABLISHMENT,CANCELED_BY_CUSTOMER,NON_PAYMENT&orderByDtDesc=true&size={size}&page={page}',
    GET_ORDER: END_POINT + 'v2/protected/orders?orderId={orderId}',
    START_ORDER: END_POINT + 'v1/protected/orders/start',
    CANCEL_ORDER: END_POINT + 'v3/protected/orders/cancel',
    FINISH_ORDER_ITEM: END_POINT + 'v1/protected/orders/item/finish',
    FINISH_ORDER: END_POINT + 'v1/protected/orders/finish',
    UNDO_ORDER_ITEM_STATUS:
      END_POINT + 'v1/protected/orders/item/returnStatusTo/{orderItemId}/{status}',
    CHANGE_TABLE: END_POINT + 'v1/protected/orders/changeTable',
    UPDATE_ORDER_STATUS: END_POINT + 'v2/protected/orders/updateStatus',
    START_PRE_SALE_ORDER:
      END_POINT + 'v1/protected/orderreservation/{orderReservationId}/start-order',

    //ORDER RESERVATION
    GET_ORDER_RESERVATION_CONFIG: END_POINT + 'v1/public/orderreservationconfig',
    ORDER_RESERVATION_CONFIG: END_POINT + 'v1/protected/orderreservationconfig',
    ORDER_RESERVATION_CONFIG_STATUS: END_POINT + 'v1/protected/orderreservationconfig/updatestatus',
    ORDER_RESERVATION_HOURS: END_POINT + 'v1/protected/orderreservationhours',
    GET_ORDER_RESERVATION_AVAILABILITY:
      END_POINT +
      'v1/public/orderreservation/availability?storeId={storeId}&startDate={startDate}&endDate={endDate}',
    ORDER_RESERVATION_AVAILABILITY: END_POINT + 'v1/protected/orderreservation/availability',

    //DASHBOARD
    GET_ORDER_SUMMARY_DASHBOARD:
      END_POINT +
      'v1/protected/dashboard/orderSummary?establishmentId={estabId}&orderStatus=RESERVED,IN_QUEUE,IN_PRODUCTION,PARTIAL_DELIVERED,FINISHED', //&startDate={startDate}&endDate={endDate}",
    GET_DASHBOARD_BIILING:
      END_POINT +
      'v1/protected/dashboard/billing?establishmentId={estabId}&startDate={startDate}&endDate={endDate}',
    GET_DASHBOARD_ORDERS:
      END_POINT +
      'v1/protected/dashboard/orders?establishmentId={estabId}&startDate={startDate}&endDate={endDate}',
    GET_CHART: END_POINT + 'v1/protected/graphics?',

    //REPORT
    GET_TOTAL_ORDERS_REPORT:
      END_POINT +
      'v1/protected/report/statistics?groupByDay={groupbyday}&establishmentId={estabId}&startDate={startDate}&endDate={endDate}&size={size}&page={page}&count={count}',
    EXPORT_PLACE_ORDERS_REPORT: END_POINT + 'v1/protected/report/export/places/{placeId}/orders',

    //RATING
    GET_RATINGS:
      END_POINT +
      'v1/protected/rate/getRateByFilter?establishmentId={establishmentId}&getAnswers=true&page={page}&size={size}&count={count}',
    GET_ORDER_RATING:
      END_POINT + 'v1/protected/rate/getRateByFilter?orderId={orderId}&getAnswers=true',
    APPROVE_RATING: END_POINT + 'v1/protected/rate/setRateStatus',
    SEND_TO_MODERATION: END_POINT + 'v1/protected/rate/sendToModeration',
    ANSWER_COMMENT: END_POINT + 'v1/protected/rate/saveRateResponse',

    //WEBSOCKET
    WEBSOCKET: END_POINT + 'v1/ws', //"https://localhost:8443/api/v1/ws"
    WEBSOCKET_ERROR_TEST: END_POINT + 'v1/ws1', //"https://localhost:8443/api/v1/ws"

    // PLACES
    SAVE_PLACE_STORE: END_POINT + 'v1/protected/places/addStoreToplace',
    UPDATE_PLACE: END_POINT + 'v1/protected/places',
    GET_PLACE_DATA: END_POINT + 'v1/protected/places/{uuid}',
    GET_ESTABLISHMENTS_FROM_PLACE: END_POINT + 'v1/protected/stores/getStoreByPlace?placeId=',
    GET_NEARBY_ESTABLISHMENTS:
      END_POINT + 'v1/public/stores?lat={lat}&lon={lon}&radius={radius}&page={page}&size={size}',
    REMOVE_STORE_FROM_PLACE: END_POINT + 'v1/protected/places/removeStoreFromplace',
    ADD_STORE_TO_PLACE: END_POINT + 'v1/protected/places/setStoreToplace',
    MANAGE_STORE: END_POINT + 'v1/protected/places/managerdelivery',

    // PLANS AND PAYMENT
    GET_CARDS: END_POINT + 'v1/protected/payment/{iuguCustomerId}',
    GET_CARD_BY_ID: END_POINT + 'v1/protected/payment/{iuguCustomerId}/{cardId}',
    CREATE_CREDIT_CARD: END_POINT + 'v1/protected/payment',
    DELETE_CREDIT_CARD: END_POINT + 'v1/protected/payment/delete/{iuguCustomerId}/{cardId}',
    SUBSCRIPTION: END_POINT + 'v1/protected/subscriptions',
    SUBSCRIPTION_PAYMENT_TYPE: END_POINT + 'v1/protected/subscriptions/paymenttype',
    ACTIVE_SUBSCRIPTION: END_POINT + 'v1/protected/subscriptions/active',
    CANCEL_SUBSCRIBE: END_POINT + 'v1/protected/subscriptions/cancel/', // {storeI}"
    SUBSCRIBE_LEGACY: END_POINT + 'v1/protected/subscriptions/legacy',
    REACTIVATE_SUBSCRIPTION: END_POINT + 'v1/protected/subscriptions/reactivate',
    START_TEST_MODULES: END_POINT + 'v1/protected/subscriptions/{id}/testmodule',
    STORE_MODULES_TESTED: END_POINT + 'v1/protected/store/{storeId}/subscription-modules',

    // QUEUE
    QUEUE: END_POINT + 'v1/protected/queue',
    CANCEL_QUEUE: END_POINT + 'v1/protected/queue/{uuid}/cancel',
    NOTIFY_QUEUE: END_POINT + 'v1/protected/queue/{uuid}/notify',
    CONFIRM_QUEUE: END_POINT + 'v1/protected/queue/{uuid}/confirm',
    NOSHOW_QUEUE: END_POINT + 'v1/protected/queue/{uuid}/noshow',
    ROLLBACK_STATUS: END_POINT + 'v1/protected/queue/{uuid}/rollbackStatus',
    CALL_NEXT: END_POINT + 'v1/protected/queue/next',

    GET_QUEUE_CONFIG: END_POINT + 'v1/public/queue-config',
    QUEUE_CONFIG: END_POINT + 'v1/protected/queue-config',

    // PASSWORD
    PASSWORDS: END_POINT + 'v1/public/display/{storeUuid}/{type}',

    // WALLET
    WALLET: END_POINT + 'v1/protected/wallet',
    WALLET_DEPOSIT: END_POINT + 'v1/protected/wallet/{storeId}/deposit',
    WALLET_LAST_INVOICE: END_POINT + 'v1/protected/wallet/lastinvoice',
    WALLET_STATEMENT: END_POINT + 'v1/protected/wallet/stores/{storeId}/statement',

    // CUSTOMERS
    CUSTOMERS: END_POINT + 'v1/protected/report/stores/{storeId}/customers',
    EXPORT_CUSTOMERS: END_POINT + 'v1/protected/report/export/stores/{storeId}/customers',
    UPDATE_CUSTOMER: END_POINT + 'v1/protected/userclient',
    SEARCH_CUSTOMER: END_POINT + 'v1/protected/stores/{storeId}/customers',
    SEARCH_CUSTOMER_SERVICES: END_POINT + 'v1/protected/report/stores/{storeId}/customers-services',

    // PAYMENT ACCOUNT
    PAYMENT_ACCOUNT_BALANCE: END_POINT + 'v1/protected/payment-accounts/balance',
    PAYMENT_ACCOUNT_STATEMENTS: END_POINT + 'v1/protected/payment-accounts/statements',
    PAYMENT_ACCOUNT_PAYBLES_STATEMENTS:
      END_POINT + 'v1/protected/payment-accounts/statements/paybles',
    WITHDRAWAL_CONFIG: END_POINT + 'v1/protected/payment-accounts/transfer-settings',
    WITHDRAW: END_POINT + 'v1/protected/payment-accounts/withdrawals',
    GENERATE_KYC_LINK: END_POINT + 'v1/protected/stores/{storeId}/kyc-qrcode',

    // CALL_ATTENDANT
    ATTENDANT_QUEUE_CONFIG: END_POINT + 'v1/protected/attendantQueueConfig',
    ATTENDANT_QUEUE: END_POINT + 'v1/protected/attendantQueue',

    //INTEGRATIONS
    SAVE_META_PIXEL: END_POINT + 'v1/protected/integrations/meta-pixel',

    LOG_ERROR: END_POINT + 'v1/public/errortrace',

    // COUPONS
    STORE_COUPONS: END_POINT + 'v1/protected/stores/{uuid}/coupons',
    COUPON_DETAILS: END_POINT + 'v1/protected/stores/{uuid}/coupons/{couponId}/details',
  },
  LANGUAGES: [
    {
      code: 'en',
      name: 'English',
    },
    {
      code: 'pt',
      name: 'Portuguese',
    },
  ],
  FEES: {
    PIX: 0.99,
    CREDIT_CARD_FEE: 3.67,
    CREDIT_CARD_FIXED_FEE: 0.99,
  },
  ERRORS: {
    TREATED: 11,
    OFFLINE: 12,
  },
};



// WEBPACK FOOTER //
// ./src/app/app.config.ts